<template>
    <div class="newsList">
        <ul>
            <Li v-for="(item,index) in dataList" :key="index" class="hoverLi">
                <div class="item">
                    <div class="title">
                        <a class="auctionFont color333" :href="item.link">{{ item.title }}</a>
                        <span class="time verdanF12 color999">{{ item.publish_at }}</span>
                    </div>
                    <div class="detail fontSong12 color666 ">
                        {{ item.desc }}
                    </div>
                </div>
            </Li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "newsList",
    props:["dataList"],
    mounted() {
        console.log(this.dataList,'dataList');
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.newsList{
    ul{
        li{
            padding: 30px 19px;
            border-bottom: 1px solid #f2f2f2;
            &:last-child{
                border-bottom: none;
            }
            .title{
                display: inline-flex;
                justify-content: space-between;
                width: 100%;
                .time{
                    max-width: 200px;
                }
            }
            .detail{
                margin-top: 14px;
                line-height: 20px;
                text-align: justify;
            }

        }
    }
}
</style>